import React, { useEffect } from "react";
import packageJson from "../package.json";
import moment from "moment";

const buildDateGreaterThan = (latestDate, currentDate) => {
	const momLatestDateTime = moment(latestDate);
	const momCurrentDateTime = moment(currentDate);

	if (momLatestDateTime.isAfter(momCurrentDateTime)) {
		return true;
	} else {
		return false;
	}
};

function withClearCache(Component) {
	function ClearCacheComponent(props) {
		useEffect(() => {
			fetch("/meta.json")
				.then((response) => response.json())
				.then((meta) => {
					const latestVersionDate = meta.buildDate;
					const currentVersionDate = packageJson.buildDate;
					const shouldForceRefresh = buildDateGreaterThan(latestVersionDate, currentVersionDate);
					if (shouldForceRefresh) {
						console.log("Not running latest version, cleaning cache and reloading");
						refreshCacheAndReload();
					} else {
						console.log("Running latest version");
					}
				})
				.catch((error) => {
					console.log("Error checking for updates:", error);
				});
		}, []);

		const refreshCacheAndReload = () => {
			if (caches) {
				// Service worker cache should be cleared with caches.delete()
				caches.keys().then((names) => {
					for (const name of names) {
						caches.delete(name);
					}
				});
			}
			// delete browser cache and hard reload
			window.location.reload(true);
		};

		return <Component {...props} />;
	}

	return ClearCacheComponent;
}

export default withClearCache;
